import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import { OrdonnanceListComponent } from './ordonnance-list/ordonnance-list.component';
import { CommonModule } from "@angular/common";
import { ModalModule } from '../modal/modal.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


const routes = [
  /*{
    path: '',
    component: OrdonnanceListComponent
  }*/
];

@NgModule({
  declarations: [
    OrdonnanceListComponent
  ],
  imports: [
    CommonModule, 
    RouterModule.forChild(routes),
    ModalModule,
    NgbModule
  ],
  exports: [
    OrdonnanceListComponent
  ],
  bootstrap: [
    OrdonnanceListComponent
  ]
})
export class OrdonnanceModule {
}
